export const layoutItems = ['chat', 'about', 'feedback', 'onboardingMode'] as const;

export type LayoutItem = (typeof layoutItems)[number];

export type LayoutProps = {
  translation: string;
  icon: string;
};

export type VariantConfig = {
  [key in LayoutItem]: LayoutProps;
};

export const sidebarToContent: VariantConfig = {
  chat: {
    translation: 'chatPage.sidebar.history.label',
    icon: 'rioglyph-chat',
  },
  about: {
    translation: 'chatPage.sidebar.about.label',
    icon: 'rioglyph-info-sign',
  },
  feedback: {
    translation: 'chatPage.sidebar.feedback.label',
    icon: 'rioglyph-send',
  },
  onboardingMode: {
    translation: 'chatPage.sidebar.onboardingMode.label',
    icon: 'rioglyph-onboarding',
  },
} as const;
